import React, { useState } from "react";
import { useSubject } from "../../context/SubjectContext";
import { useLocation } from "react-router-dom";
import AssessmentCriteriaHeader from "../AssessmentCriteria/AssessmentCriteriaHeader";
import "./ACUpdateMarksCentrePanel.css";
import PropTypes from "prop-types";
import MarkSubmissionConfirmModal from "../MarkSubmission/MarkSubmissionConfirmModal";
import { useCenter } from "../../context/CenterContext";
import { useConsortiaCenter } from "../../context/ConsortiaCenterContext";
import { getCenterType, checkunitIsConsortiaUnit } from "../../utils/utils";

 
const ACUpdateMarksCentrePanel = ({
  allCandidatesCompleted,
  selectedCandidateObj,
  candidatePayloadData,
  criteriaAchievedCount,
  updatedCriteriaAchievedCount,
  candidateMarks,
  showOriginalMarksError,
  isUpdatedActive,
  onSave = () => {},
  submissionPayload = [],
  downloadPayload = [],
  selectedCandidate = null,
  candidateDataMap = {},
  mode = "edit",
  onSubmit,
  currentSection,
  totalMarks,
  totalCriteria,
  showModal,
  setShowModal,
  originalTotalCriteriaScore,
   updatedTotalCriteriaScores,
  handleConfirmSubmit,
  originalsSubmitted,
  updatedSubmitted,
  // NEW: attention candidates from parent
  missingOrInvalidCandidates = [],
}) => {
  const { subjectData } = useSubject();
  const location = useLocation();
  const { selectedSubject, selectedSubjectCode, selectedSubjectId } = subjectData || {};

  const [isChecked, setIsChecked] = useState(false);
 
  const {
    unit,
    sessionId,
    sessionStartDate,
    sessionEndDate,
    visitDate,
    additionalVisitDate,
  } = location.state || {};
  const { centerNumber } = useCenter();
   const { consortiaCentres = [] } = useConsortiaCenter();
 
   const currentCentreType =
     getCenterType(consortiaCentres, Number(centerNumber), selectedSubject, selectedSubjectId) || "";
   const unitcode = unit.split(" ")[0];
   const consortiaUnitcode =
     String(unit ?? "")
       .toUpperCase()
       .match(/^[A-Z0-9]+/)?.[0] || "";
   const isConsortiaUnit = checkunitIsConsortiaUnit(
     consortiaCentres,
     centerNumber,
     sessionId,
     consortiaUnitcode,
   );
  const originalPanelClasses = `step-panel is-flex ${!isUpdatedActive ? "is-active" : ""}`;
  const updatedPanelClasses = `step-panel is-flex ${isUpdatedActive ? "is-active" : ""}`;
 
  const onClose = () => {
    setShowModal(false);
    setIsChecked(false);
  };

   const candidateId = selectedCandidateObj?.centreCandidateNumber;
  const updatedTotalMarks =
  updatedTotalCriteriaScores[candidateId] ??
  selectedCandidateObj?.criteriaUpdated?.[0]?.updatedTotalCriteriaScore ??
  0;
 
  const attentionNamesText =
    missingOrInvalidCandidates && missingOrInvalidCandidates.length
      ? `${missingOrInvalidCandidates.join(", ")}`
      : "";
  return (
    <div id="pageMainContent" style={{ paddingLeft: "240px" }}>
      <MarkSubmissionConfirmModal
        isOpen={showModal}
        onClose={onClose}
        rows={submissionPayload}
        isChecked={isChecked}
        setIsChecked={setIsChecked}
        type={"Stage3acmarks"}
        submitACCUpdateMarks={handleConfirmSubmit}
      />
      <AssessmentCriteriaHeader

        selectedSubject={selectedSubject}
        selectedSubjectCode={selectedSubjectCode}
        visitDate={visitDate}
        sessionId={sessionId}
        sessionStartDate={sessionStartDate}
        sessionEndDate={sessionEndDate}
        unit={unit}
        mode={mode}
        onSave={onSave}
        submissionPayload={submissionPayload}
        downloadPayload={downloadPayload}
        subjectData={subjectData}
        onSubmit={onSubmit}
        allCandidatesCompleted={allCandidatesCompleted}
        // Pass attention candidates to header (if it renders banners/messages)
        missingOrInvalidCandidates={missingOrInvalidCandidates}
        assessmentCandidateData={[]}
        achievedCount={""}
        totalCriteria={""}
        candidateMarks={""}
        totalMarks={""}
        isStage3={true}
        additionalVisitDate={additionalVisitDate}
        selectedCandidate={selectedCandidate}
        candidateDataMap={candidateDataMap}
        currentSection={currentSection}
        originalsSubmitted={originalsSubmitted}
        updatedSubmitted={updatedSubmitted}
      />
 
      <div className="xcontainer" style={{ backgroundColor: "#FFFFFF" }}>
        <section className="section mt-0 py-0 pr-4" style={{ padding: "3rem" }}>
          <div className="columns is-fullheight pt-4">
            <div className="column">
              <div className={originalPanelClasses} style={{ cursor: "pointer" }}>
                <span className="number">1</span>
                <span>
                  <strong>Enter and submit original marks</strong>
                  <br />
                  You must enter the original assessment criteria marks for all listed candidates and then select submit marks.
                </span>
              </div>
            </div>
 
            <div className="column">
              <div className={updatedPanelClasses} style={{ cursor: "pointer" }}>
                <span className="number">2</span>
                <span>
                  <strong>Add updated marks</strong>
                  <br />
                  You must enter the updated assessment criteria marks for all listed candidates and then select submit marks.
                </span>
              </div>
            </div>
          </div>
          {/* Acceptance-criteria banner for attention candidates (shown after Save) */}
          {!showOriginalMarksError && missingOrInvalidCandidates?.length > 0 && (
            <div>
              <div
                id="notificationPanel"
                className="notification-panel mt-2 mb-2"
                role="alert"
                aria-live="polite"
                style={{ display: "block" }}
              >
                <div className="notification-title">
                  <span className="icon" aria-hidden="true">
                    <i className="fas fa-exclamation-triangle"></i>
                  </span>
                  <span>
                    The following candidates have missing or incorrect
                    assessment criteria.
                  </span>
                </div>
                <div className="missing-candidates-list">
                  <strong>{missingOrInvalidCandidates.join(", ")}</strong>
                </div>
                <div className="notification-content" style={{color:"#333333"}}>
                  <div>
                    Please remember to submit this information 3 working days
                    ahead of your scheduled visit.
                  </div>
                </div>
              </div>
            </div>
          )}
 
          {!showOriginalMarksError && (
            <>
              <div className="ac-centre-card mt-2">
                <div
                  className="candidate-header is-fixed is-flex is-align-items-center"
                  style={{ backgroundColor: "#F7F7F7", justifyContent: "space-between" }}
                >
                   <div
                  className="is-size-5"
                  style={{
                    lineHeight: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                    {((currentCentreType === "Lead" && isConsortiaUnit) || (currentCentreType === 'Rest' && mode ==='view' && isConsortiaUnit) ) && (
                    <span style={{ fontSize: "13px", fontWeight: "500" }}>
                      CENTRE:{" "}
                      {candidatePayloadData.find(
                        (val) =>
                          val.centreCandidateNumber === selectedCandidate,
                      )?.centreNumber || ""}
                    </span>
                  )}
                  <div className="is-size-5" style={{ lineHeight: 1 }}>
                    {selectedCandidateObj?.candidateName}
                    <br />
                    <span className="candidate-number has-text-weight-normal is-size-6">
                      {selectedCandidateObj?.centreCandidateNumber}
                    </span>
                  </div>
                  </div>
 
                  <div style={{ display: "flex", gap: "1rem", marginLeft: "auto" }}>
                    <div className="tag card xis-dark xis-medium p-5 has-background-white">
                      <span className="is-size-6">
                        <span>
                          Criteria achieved:{" "}
                          {currentSection === "originalMarks"
                            ? criteriaAchievedCount[selectedCandidate] || 0
                            : updatedCriteriaAchievedCount[selectedCandidate] || 0}
                        </span>{" "}
                        {" / "}
                        <span>{totalCriteria}</span>
                      </span>
                    </div>
 
                    <div className="tag card xis-dark xis-medium p-5" style={{ backgroundColor: "#E0E0E0" }}>
                      {isUpdatedActive ? "Updated total marks for this candidate" : "Original total marks for this candidate"}:&nbsp;&nbsp;
                      <span className="is-size-6">
                        <span id="varCandidateScore"> {isUpdatedActive
                            ? updatedTotalMarks
                            : originalTotalCriteriaScore}
                        </span>{" "}
                        {" / "}
                        <span>{totalMarks}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="subject-page-content xmt-0" style={{ top: "216px", width: "100%" }}></div>
            </>
          )}
          {/* ERROR STATE */}
          {showOriginalMarksError && (
            <div className="columns mt-4">
              <div className="column is-full">
                <div id="pnlOriginalMarksErrorMessage" className="notification is-danger is-flex">
                  <span className="icon mr-4" aria-hidden="true">
                    <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24">
                      <path d="M12 7c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1zm-.01-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-3h-2v-2h2v2z"></path>
                    </svg>
                  </span>
                  <span>
                    <span id="varOriginalMarksErrorMessage">
                      You need to enter and submit your original marks for all listed candidates first.
                    </span>
                  </span>
                </div>
              </div>
            </div>
          )}
        </section>
      </div>
    </div>
  );
};
 
export default ACUpdateMarksCentrePanel;
 
ACUpdateMarksCentrePanel.propTypes = {
  allCandidatesCompleted: PropTypes.bool,
  selectedCandidateObj: PropTypes.object,
  candidatePayloadData: PropTypes.array,
  criteriaAchievedCount: PropTypes.number,
  candidateMarks: PropTypes.object,
  onUpdatedMarksClick: PropTypes.func,
  showOriginalMarksError: PropTypes.bool,
  onOriginalMarksClick: PropTypes.func,
  isUpdatedActive: PropTypes.bool,
  onSave: PropTypes.func,
  submissionPayload: PropTypes.array,
  downloadPayload: PropTypes.array,
  selectedCandidate: PropTypes.object,
  candidateDataMap: PropTypes.object,
  mode: PropTypes.oneOf(["edit", "view"]),
  onSubmit: PropTypes.func,
  currentSection: PropTypes.string,
  totalMarks: PropTypes.number,
  totalCriteria: PropTypes.number,
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  originalTotalCriteriaScore: PropTypes.number,
  handleConfirmSubmit: PropTypes.func,
  // NEW
  missingOrInvalidCandidates: PropTypes.array,
};
 
ACUpdateMarksCentrePanel.defaultProps = {
  onSave: () => {},
  submissionPayload: [],
  downloadPayload: [],
  selectedCandidate: null,
  candidateDataMap: {},
  mode: "edit",
  // NEW
  missingOrInvalidCandidates: [],
};
 